export default __webpack_public_path__ + "static/media/473.245f30ac.jpg";